var _circle, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDocumentSignedIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 107,
    height: 106,
    viewBox: "0 0 107 106",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 53.404,
    cy: 52.929,
    r: 52.929,
    fill: "#E8F7FF"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    stroke: "#00A3FA",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    strokeWidth: 2.8,
    d: "M81 53.235c-7.67 0-10.226 12.55-14.122 12.55-1.339 0 .974-12.55-1.095-12.55-2.435 0-7.305 15.687-13.392 15.687-3.408 0-5.6-5.177-5.6-11.294 0-9.57 4.261-16.942 8.522-16.942 7.913 0-4.748 34.51-18.26 34.51C29.625 75.196 25 62.961 25 54.02 25 33.94 34.617 25 38.635 25c5.356 0 5.843 5.96 5.843 8.157C44.478 54.02 25 81 25 81"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDocumentSignedIcon);
export default __webpack_public_path__ + "static/media/document-signed-icon.4b2842f7281a01285ea086c4e7ab808c.svg";
export { ForwardRef as ReactComponent };